import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { dashboardModules } from '../data';
import type { PlatformSubpageConfig } from '../types';

export const DashboardContent: React.FC<{ config: PlatformSubpageConfig }> = ({ config }) => {
  const [openId, setOpenId] = useState<string>(dashboardModules[0].id);

  return (
    <SiteSection className="platform-sub-interactive">
      <SiteSectionHeader
        eyebrow="INTERACTIVE"
        title={config.sections.title}
        subtitle={config.sections.subtitle}
        align="center"
      />
      <div className="platform-sub-split">
        <div className="platform-sub-accordion">
          {dashboardModules.map((mod) => {
            const isOpen = openId === mod.id;
            return (
              <div key={mod.id} className="platform-sub-accordion__item">
                <button
                  type="button"
                  className="platform-sub-accordion__trigger"
                  aria-expanded={isOpen}
                  onClick={() => setOpenId(isOpen ? '' : mod.id)}
                >
                  <span>{mod.title}</span>
                  <ChevronDown
                    size={18}
                    className={`platform-sub-accordion__icon${isOpen ? ' platform-sub-accordion__icon--open' : ''}`}
                    aria-hidden
                  />
                </button>
                {isOpen ? (
                  <div className="platform-sub-accordion__body">
                    <p>{mod.description}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
        <figure className="platform-sub-screenshot">
          <img
            src="/images/home/platform-dashboard-ui.png"
            alt="Partner dashboard UI preview"
            width={640}
            height={400}
            loading="lazy"
            decoding="async"
          />
        </figure>
      </div>
    </SiteSection>
  );
};
